export default "__VITE_ASSET__I3$0DkYS__"